export const AMENDMENT_TYPES = [
    { id: 1, label: 'Individual' },
    { id: 2, label: 'Bancada' },
    { id: 3, label: 'Comissão' },
    { id: 4, label: 'OP' },
];

export const AMENDMENT_STATUSES = [
    { id: 1, label: 'Não Iniciada', color: 'default' as const },
    { id: 2, label: 'Em Execução', color: 'info' as const },
    { id: 3, label: 'Concluída', color: 'success' as const },
    { id: 4, label: 'Cancelada', color: 'error' as const },
];

export function getAmendmentTypeLabel(id?: number): string {
    return AMENDMENT_TYPES.find((t) => t.id === id)?.label || '-';
}

export function getAmendmentStatus(id?: number) {
    return AMENDMENT_STATUSES.find((s) => s.id === id);
}
